export const useCasesData = [
    {
        id: 1,
        icon: (
            <svg width="56" height="56" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <path d="M22 12h-4l-3 9L9 3l-3 9H2"/>
                <circle cx="12" cy="12" r="10"/>
            </svg>
        ),
        title: "Human-Centric Services, Insurance & Risk Management",
        description: "Real-time emotional intelligence for wellbeing monitoring, fraud detection, and risk assessment.",
        features: [
            "Live facial emotion detection",
            "Voice sentiment and stress analysis",
            "Emotional Digital Twin visualization",
            "GDPR-compliant risk assessment"
        ],
        videoUrl: "/assets/videos/EIE_Presentation_optimized.mp4",
        featured: true
    },
    {
        id: 2,
        icon: (
            <svg width="56" height="56" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                <circle cx="9" cy="7" r="4"/>
                <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
                <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
            </svg>
        ),
        title: "Media & Sport - AlphaHub Social Platform",
        description: "Emotional content recommendations for premium fashion, sports, and luxury venues through mobile app.",
        features: [
            "Real-time emotional state detection",
            "Personalized content matching",
            "Premium venue experiences",
            "Social engagement optimization"
        ],
        videoUrl: "/assets/videos/AlphaHub_DEMO_optimized.mp4"
    },
    {
        id: 3,
        icon: (
            <svg width="56" height="56" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <rect x="2" y="7" width="20" height="15" rx="2" ry="2"/>
                <polyline points="17 2 12 7 7 2"/>
            </svg>
        ),
        title: "VR - Neural Network Navigation",
        description: "Immersive virtual reality experience to explore the emotional graph neural network in 3D.",
        features: [
            "3D visualization of neural connections",
            "Interactive emotional pathway exploration",
            "Immersive content relationship mapping",
            "Real-time network dynamics"
        ],
        videoUrl: "/assets/videos/EIE-VR.mp4"
    }
];
